import { useState } from "react";
import { BoardOperationsOne } from "./BoardOperationsOne";
import { BoardOperationsTwo } from "./BoardOperationsTwo";
import { Pagination } from "antd";

export const BoardOperations = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const componentsToShow = [BoardOperationsOne, BoardOperationsTwo];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div
    className="relative min-h-screen flex flex-col"
    >
      <div className="flex-1">
        {componentsToShow.map((Component, index) => {
          if (index === currentPage - 1) {
            return <Component key={index} />;
          }
          return null;
        })}
      </div>
      <div className="flex justify-end items-center mb-5" >
        <Pagination
          current={currentPage}
          pageSize={itemsPerPage}
          total={componentsToShow.length}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};
